
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function AileHukuku() {
  const serviceFeatures = [
    {
      title: 'Boşanma Davaları',
      description: 'Anlaşmalı ve çekişmeli boşanma süreçleri',
      icon: 'ri-heart-line'
    },
    {
      title: 'Velayet İşleri',
      description: 'Çocukların velayeti ve ziyaret hakları',
      icon: 'ri-parent-line'
    },
    {
      title: 'Mal Rejimi Davaları',
      description: 'Mal rejimi ve mal paylaşımı davaları',
      icon: 'ri-home-heart-line'
    },
    {
      title: 'Ziynet Alacağı Davaları',
      description: 'Ziynet alacağı ve nafaka hesaplaması',
      icon: 'ri-money-dollar-circle-line'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/60a761a25ab7dcdcfbbdace1cd33ad2f.jpg')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center mb-4 animate-fade-in-up">
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors font-poppins font-light">
                Hizmetler
              </Link>
              <i className="ri-arrow-right-s-line mx-2 text-gray-400"></i>
              <span className="text-white font-poppins font-light">Aile Hukuku</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins" style={{ animationDelay: '0.1s' }}>
              Aile Hukuku
            </h1>
            
            <p className="text-xl text-gray-200 leading-relaxed animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
              Boşanma, velayet, nafaka, mal paylaşımı, evlat edinme ve aile içi hukuki sorunlar 
              konularında hassas ve profesyonel hukuki danışmanlık hizmetleri sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Service Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
              Aile Hukuku Hizmetlerimiz
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
              Aile hukuku alanında hassas ve profesyonel hizmetler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {serviceFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg border border-gray-100 p-8 hover:shadow-xl transition-all duration-300 animate-fade-in-up hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 font-poppins">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed font-poppins font-light">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Content */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 animate-fade-in-up font-poppins">
            Aile Hukuku Danışmanlığımız
          </h2>
          
          <div className="space-y-6 text-slate-600 leading-relaxed font-poppins font-light">
            <p className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              Aile hukuku alanında uzman kadromuzla, müvekkillerimizin en hassas dönemlerinde 
              yanlarında yer alıyor, hukuki haklarının korunması için gereken tüm adımları 
              atıyoruz. Boşanma süreçlerinde hem anlaşmalı hem de çekişmeli davalar konusunda 
              deneyimliyiz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              Çocukların üstün yararını gözettiğimiz velayet davalarında, ziyaret hakları ve 
              nafaka hesaplamalarında adil çözümler için çalışıyoruz. Mal rejimi davaları ve 
              ziynet alacağı taleplerinde müvekkillerimizin haklarını koruyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              Evlat edinme süreçleri, aile içi şiddet davaları ve diğer aile hukuku 
              uyuşmazlıklarında hassas yaklaşımımızla müvekkillerimize destek oluyoruz. 
              Her durumda ailenin ve çocukların yararını ön planda tutuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 animate-fade-in-up font-poppins">
            Aile Hukuku Danışmanlığı
          </h2>
          <p className="text-lg text-gray-200 mb-8 animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
            Hassas süreçlerinizde yanınızdayız
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button className="bg-white text-slate-900 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Boşanma Danışmanlığı
            </button>
            <button className="border border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-slate-900 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Hukuki Destek
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
